import React from "react";
import classNames from "classnames";
import {format} from "date-fns";
import {Input, MenuItem, Select} from "@material-ui/core";

import {useIsAdministrator} from "../../../../context/user";
import {applicationFiltersMap, InputType} from "../../const";
import {DatePicker} from "../../../Controls/DatePicker";

import cn from "./Filter.module.scss";

const logicalModifierOptions = [
  {label: 'And', value: '&'},
  {label: 'Or', value: '||'},
];

export function Filter({filter, isFirst, onChange, serviceAgencies, insuranceAgencies}) {
  const isSuperAdmin = useIsAdministrator()
  const {logicalModifier, equalityModifier, field, value } = filter;
  const fieldConfig = applicationFiltersMap[field];

  function handleChange(event) {
    onChange(filter, {...filter, value: event.target.value});
  }

  function handleLogicalModifierChange(event) {
    onChange(filter, {...filter, logicalModifier: event.target.value})
  }

  function handleEqualityModifierChange(event) {
    onChange(filter, {...filter, equalityModifier: event.target.value})
  }

  function handleDateChange(date) {
    let value = null;
    try {
      value = format(date, 'yyyy-MM-dd');
    } catch {
    }
    onChange(filter, {...filter, value});
  }

  function handleFieldChange(event) {
    onChange(filter, {...filter, field: event.target.value, value: ''});
  }

  return (
    <div className={cn.filter}>
      {!isFirst && (
        <Select
          onChange={handleLogicalModifierChange}
          value={logicalModifier}
          className={classNames(cn.field, cn.logicalModifier)}
          autoWidth={false}
        >
          {logicalModifierOptions.map(option => (
            <MenuItem key={option.value} value={option.value}>{option.label}</MenuItem>
          ))}
        </Select>
      )}

      <Select
        onChange={handleFieldChange}
        value={field}
        className={classNames(cn.field, cn.applicationField)}
      >
        {Object.keys(applicationFiltersMap).filter(key => {
          // only admins can filter by insurance agency and service agency
          if (['insurance_agency_id', 'service_agency_id'].includes(key)) {
            return isSuperAdmin;
          }
          return true;
        }).map(key => (
          <MenuItem key={key} value={key}>{applicationFiltersMap[key].label}</MenuItem>
        ))}
      </Select>


      <Select
        onChange={handleEqualityModifierChange}
        value={equalityModifier}
        className={classNames(cn.field, cn.equalityModifier)}
      >
        {fieldConfig.filters.map(option => (
          <MenuItem key={option.value} value={option.value}>{option.label}</MenuItem>
        ))}
      </Select>

      <div className={classNames(cn.field, cn.valueField)}>
        {fieldConfig.type === InputType.TEXT && (
          <Input
            placeholder="Value"
            value={value}
            onChange={(event) => handleChange(event)}
            classes={{root: cn.input}}
            fullWidth
          />
        )}
        {fieldConfig.type === InputType.SELECT && (
          <Select
            value={value}
            onChange={(event) => handleChange(event)}
            className={cn.select}
          >
            {fieldConfig.options && fieldConfig.options.map(option => (
              <MenuItem key={option.value} value={option.value}>{option.label}</MenuItem>
            ))}
            {field === 'service_agency_id' && (serviceAgencies.map(agency => (
                <MenuItem key={agency.id} value={agency.id}>{agency.name}</MenuItem>
              ))
            )}
            {field === 'insurance_agency_id' && (insuranceAgencies.map(agency => (
                <MenuItem key={agency.id} value={agency.id}>{agency.name}</MenuItem>
              ))
            )}
          </Select>
        )}
        {fieldConfig.type === InputType.DATE && (
          <DatePicker
            value={value || null}
            onChange={handleDateChange}
            InputProps={{
              classes: {root: cn.datePicker}
            }}
          />
        )}
      </div>
    </div>
  )
}
